import { render, staticRenderFns } from "./mensagem.vue?vue&type=template&id=0c744495"
import script from "./mensagem.vue?vue&type=script&lang=js"
export * from "./mensagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports